import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import Divider from 'redesign/components/atoms/Divider'
import RadioFormGroup from 'redesign/components/molecules/RadioFormGroup'
import EmployeeSearch from 'redesign/components/organisms/employee-search'
import { Container, TenantSectionContainer } from './styles'
import type { RequestUserDataContentProps } from './types'

const RequestUserDataContent: React.FC<RequestUserDataContentProps> = ({
  tenantSelectRadioProps,
  employeeSearchProps,
  showTenantSelect = false,
}) => {
  const { t } = useFavurTranslation()

  return (
    <Container>
      {showTenantSelect && (
        <>
          <TenantSectionContainer>
            <RadioFormGroup legend={t('absenceRequest.new.personUuid.label')} {...tenantSelectRadioProps} />
          </TenantSectionContainer>
          <Divider removeHeight />
        </>
      )}
      <EmployeeSearch {...employeeSearchProps} isCentered reducedPadding />
    </Container>
  )
}

export default RequestUserDataContent
